var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.apply === 'word' ? 'flex flex-wrap justify-around' : '',domProps:{"innerHTML":_vm._s(_vm.magicWord)}})
}
var staticRenderFns = []

export { render, staticRenderFns }